export const messages = {
  email: 'E-mail address',
  first_name: 'First name',
  last_name: 'Last name',
  middle_name: 'Middle name',
  other_names: 'Other names',
  dob: 'DOB',
  daytime_number: 'Day phone number',
  cell_number: 'Cell phone number',
  ssn: 'SSN',
  npi: 'NPI',
  save_changes: 'Save changes',
  close: 'Close',
  account_settings: 'Account Settings',
  general: 'General',
  security: 'Security',
  password_label: 'Password',
  password_change_description:
    'Would you like to change your password? Click the button below and set a unique password to protect your personal Surglogs account.',
  password_change_button_text: 'Change password',
  pin_label: 'PIN ({{ length }}-digits)',
  pin_change_description: 'Pin code is used to access our mobile application.',
  pin_change_button_text: 'Change PIN',
  show_optional_details: 'Show additional details',
  hide_optional_details: 'Hide additional details',
  updateFailed: 'Update Failed',
  isRequired: 'Required field',
  isValidPhone: 'Field must be valid US phone number',
  isValidSSN: 'SSN must be 9 digits',
  isValidNPI: 'NPI must be 10 digits',
  passwordEditTitle: 'Change password',
  passwordEditDescriptionText:
    'Set a unique password to protect your personal Surglogs account.',
  newPasswordLabel: 'New password',
  newPasswordPlaceholder: 'New user password',
  retypeNewPasswordLabel: 'Retype new password',
  retypeNewPasswordPlaceholder: 'Password confirmation',
  passwordLabel: 'Current password',
  passwordPlaceholder: 'User password',
  buttonLabel: 'Save password',
  invalid: 'Passwords must be the same',
  revertChanges: 'Revert changes',
  cancel: 'Cancel',
  pinEditDescriptionText: 'Pin code is used to access our mobile application.',
  pinEditTitle: 'Change PIN',
  passwordInputPlaceholder: 'User password',
  passwordConfirmationButton: 'Save pin',
  invalid_password: 'Invalid actual password.',
  invalid_new_password:
    'Please create a password that has not been used before.',
  unspecifiedError: 'Something went wrong. Please try again later.',
  incorrect_login:
    'You have been temporarily locked out of your account due to too many wrong attempts. Please try again in',
  minute: 'minute',
  minute_plural: 'minutes',
  second: 'second',
  second_plural: 'seconds',
  invalid_grant:
    'Authentication has been unsuccessful. Please check your email and password and try again.',
  address_line: 'Address line',
  city: 'City',
  zip: 'ZIP',
  state: 'State',
  country: 'Country',
  title: 'Title',
  zipLengthErrorMessage: 'ZIP must be 5 digits',
  tooltipState: 'State is filled automatically based on ZIP',
  mfaLabel: 'Multi-Factor Authentication (MFA)',
  mfaDescription:
    'Add an extra layer of protection with a second verification step, like an authenticator app.',
  setMfa: 'Set  MFA',
  mfaSetup: {
    step1: {
      modalTitle: 'Authentication app',
      description:
        'To enable multi-factor authentication (MFA) through an authenticator app, you need to scan the provided QR code.',
      additionalInfo:
        'If you have any problems with scanning, enter this code manually into the app',
      next: 'Next step',
      cancel: 'Cancel',
      errorWhileLoadingSetup: 'Error occurred while loading setup',
      skip: 'Skip',
    },
    step2: {
      description:
        'Enter the code generated by the authentication app based on the QR code scanned in the previous step',
      enableMFA: 'Enable MFA',
      cancel: 'Cancel',
      forgotScan: 'Forgot to scan the code?',
      providedCode: 'Provided code',
      missingProvidedCode: 'Access code is required.',
      mfaCodeLabel: 'Provided code',
    },
    step: 'Step',
    tryAgain: 'Try again',
    countdown: {
      setup: 'You have {{seconds}} seconds to complete the setup',
      login: 'You have {{seconds}} seconds to enter the code',
    },
  },
  mfaMethods: {
    authenticatorApp: {
      title: 'Authenticator App',
      setupTitle: 'Set up app',
      description:
        'Use an app like Google Authenticator or Authy to generate codes',
    },
    status: 'Status',
    enabled: 'Enabled',
    notSetUp: 'Not set up',
    revokeMfa: 'Revoke MFA',
    revokeSuccessful: {
      title: 'MFA Revoked',
      text: 'MFA has been revoked successfully.',
    },
    revokeFailed: {
      title: 'Error Revoking MFA',
      text: 'There was a problem revoking MFA, please try again later.',
    },
  },
  mfaCodeVerify: {
    missingProvidedCode: 'Access code is required.',
    invalidCode:
      'Invalid access code. Please enter the current code from your authenticator.',
    success: {
      title: 'MFA Set Up',
      text: 'MFA has been successfully set up.',
    },
  },
  passwordInput: {
    isLong: 'must be at least 8 characters',
    isNumeric: 'must contain at least one numeric character [0-9]',
    isUppercase: 'must contain at least one upper case letter',
    isLowercase: 'must contain at least one lower case letter',
    isWithSpecialChar:
      'must contain at least one special character [!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~]',
  },
  isSequence: 'PIN can not be a sequence of numbers',
  isRepetitive: 'PIN can not be repetitive',
} as const
